module.exports = __webpack_public_path__ + "img/banner_new_7.7f6bdac0.png";